<template lang="pug">
    div(class="c-form")
        v-layout(raw wrap)
            v-flex(xs12 v-if="isChampion")

                // Business Name field
                v-text-field(
                    :label="$t('profile.fields.businessName')"
                    name="name"
                    :value="user.business.name"
                    outline
                    append-icon="lock"
                    disabled
                )

            v-flex(xs12)
                // Full Name field
                v-text-field(
                    :label="$t('profile.fields.fullName')"
                    name="fullName"
                    :value="user.fullName"
                    outline
                    append-icon="lock"
                    disabled
                )

            v-flex(xs12)
                // Email field
                v-text-field(
                    :label="$t('profile.fields.email')"
                    name="email"
                    type="email"
                    :value="user.email"
                    outline
                    append-icon="lock"
                    disabled
                )

            v-flex(xs12)
                // Phone field
                v-text-field(
                    :label="$t('profile.fields.contactPhone')"
                    name="phone"
                    :value="user.phone"
                    mask="###-###-######-####"
                    outline
                    append-icon="lock"
                    disabled
                )
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        $_veeValidate: {
            validator: 'new'
        },
        computed: {
            ...mapGetters('auth', ['user', 'isChampion'])
        }
    };
</script>
